export default __webpack_public_path__ + "static/WPS-P2P_IN-6001_09-74abde9ee684d4fd23d179b45b3bfb53.webp";